"use client"
/* */
const illustratedMessage = "flow--illustrated-message";
const icon = "flow--illustrated-message--icon";
const text = "flow--illustrated-message--text";
const heading = "flow--illustrated-message--heading";
const actionGroup = "flow--illustrated-message--action-group";
const progressBar = "flow--illustrated-message--progress-bar";
const primary = "flow--illustrated-message--primary";
const danger = "flow--illustrated-message--danger";
const dark = "flow--illustrated-message--dark";
const light = "flow--illustrated-message--light";
const styles = {
	illustratedMessage: illustratedMessage,
	icon: icon,
	text: text,
	heading: heading,
	actionGroup: actionGroup,
	progressBar: progressBar,
	primary: primary,
	danger: danger,
	dark: dark,
	light: light
};

export { actionGroup, danger, dark, styles as default, heading, icon, illustratedMessage, light, primary, progressBar, text };
//# sourceMappingURL=IllustratedMessage.module.scss.mjs.map
